import { Component, OnInit } from '@angular/core';
import { LoginService } from '../shared/service/login/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    isUsuario : boolean = false;
    isAdmin : boolean = false;
    isGestor : boolean = false;
    habilitarApiClassic: boolean = true;
    habilitarOAuth: boolean = true;
    roles : string[];
    userName: string;

    constructor(private loginService : LoginService,
        private router: Router) {

    }

    ngOnInit() {
        this.loginService.newLoginEmitter.subscribe((currentUser) => {
            this.habilitarApiClassic = currentUser.habilitarApiClassic;
            this.habilitarOAuth = currentUser.habilitarOAuth;
        });

        let host = location.host;
        if (host.startsWith('www.')) {
            host = host.substring(4);
        }
    }

    isUserLoggedIn(): boolean{
        let logged = this.loginService.isLoggedIn && !this.router.url.includes("/renovacao-certificado");
        this.roles = this.loginService.getRoles();

        if (logged) {
            this.isUsuario = this.roles.indexOf("USUARIO") >= 0;
            this.isAdmin = this.roles.indexOf("ADMINISTRADOR") >= 0;
            this.isGestor = this.roles.indexOf("GESTOR") >= 0;

            if(localStorage.getItem("currentUser")) {
                let jsUser = JSON.parse(localStorage.getItem("currentUser"));

                if (typeof jsUser.nome !== 'undefined' ){
                    this.userName = jsUser.nome.split(' ')[0];
                }
            }
        }

        return logged;
    }

    logout() {
        this.loginService.logout();
    }

    getRouterLink() {

        let logged = this.isUserLoggedIn();

        if (logged) {
            this.isGestor = this.roles.indexOf("GESTOR") >= 0;
            if (this.isGestor) {
                this.router.navigate(['/relatorios']);
            } else {
                this.router.navigate(['/carteira-certificado']);
            }
        } else {
            this.router.navigate(['/login']);
        }
    }

    isVarejo(): boolean{
        return (localStorage.getItem('isVarejo') === 'true');
    }

    hasRenovation(): boolean {
        let renovation = false;
        if(localStorage.getItem("currentUser")) {
            let jsUser = JSON.parse(localStorage.getItem("currentUser"));
            renovation = jsUser.renovation;
        }
        return renovation;
    }
}
